// @flow

import React from 'react';
import ReactDOM, { render } from 'react-dom';
import {getDocument, getWindow} from "../Helpers/browsers";
import {App} from "../VideoRows/App";

import LegacyHomepage from './legacy';

let page = new LegacyHomepage({
  container: '#homepage'
});

window.APP = 'Homepage';

const DEFAULT_ROWS = {
  name: "Defaults",
  rows: [
    ['Popular Shows', 'show/trending/', {view: 'show'}],
    ['Recently Added', 'watchables/recent/', {view: 'video'}],
    ['Expiring Soon', 'watchables/expiring/', {view: 'video'}],
    ['Popular On Passport', 'show/trending/?filter=passport', {view: 'show'}],
    ['Drama', 'watchables/genre/drama/', {view: 'video'}],
    ['History', 'watchables/genre/history/', {view: 'video'}],
    ['Food', 'watchables/genre/food/', {view: 'video'}],
    ['Indie Films', 'watchables/genre/indie-films/', {view: 'video'}],
    ['Science', 'watchables/genre/science-and-nature/', {view: 'video'}],
    ['Arts', 'watchables/genre/arts-and-music/', {view: 'video'}],
    ['Culture', 'watchables/genre/culture/', {view: 'video'}],
    ['News and Public Affairs', 'watchables/genre/news-and-public-affairs/', {view: 'video'}],
    ['Home', 'watchables/genre/home-and-how-to/', {view: 'video'}]
  ]
};
getWindow().then(window => {
  getDocument().then(document => {
    let root = document.getElementById('homepage-content');

    if (root) {
      render(
        <App mobileView={window.outerWidth < 640} rows={(window.CONTENT_ROWS || DEFAULT_ROWS).rows} />,
        root
      );
    }
  });
});